import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FinalConclusion } from "../../eff-final-conclusion-box/models/final-conclusion.model";
import { EffFinalConclusionBoxComponent } from "../../eff-final-conclusion-box/eff-final-conclusion-box.component";
import { EffButtonComponent } from "../../../../common/eff-button/eff-button.component";
import { EffPopupHeaderComponent } from "../../../../common/popups/eff-popup-header/eff-popup-header.component";

@Component({
    selector: "eff-final-conclusion-popup",
    templateUrl: "./eff-final-conclusion-popup.component.html",
    styleUrls: ["./eff-final-conclusion-popup.component.scss"],
    imports: [EffFinalConclusionBoxComponent, EffButtonComponent, EffPopupHeaderComponent]
})
export class EffFinalConclusionPopupComponent {
    data = inject(MAT_DIALOG_DATA);
    dialogRef = inject<MatDialogRef<EffFinalConclusionPopupComponent>>(MatDialogRef);

    title: string;
    finalConclusion: FinalConclusion;
    constructor() {

        this.finalConclusion = {
            author: this.data.username,
            authorLabelKey: this.data.authorLabelKey,
            availableScores: this.data.scores,
            conclusion: this.data.conclusion ?? "",
            score: this.data.score,
            hideScore: this.data.hideScore,
            message: this.data.message,
        };
    }

    onFinalConclusion() {
        this.data.onSave(this.finalConclusion);
        this.dialogRef.close();
    }

    isButtonEnabled() {
        let isConclusionValid =
            this.finalConclusion.conclusion != "" &&
            this.finalConclusion.conclusion != undefined &&
            this.finalConclusion.conclusion != null;

        if (this.finalConclusion.hideScore) {
            return isConclusionValid;
        } else {
            return this.finalConclusion.score > 0 && isConclusionValid;
        }
    }
}
